import { Controller } from "stimulus";

export default class extends Controller {
  imgClicked() {
    var x = 'app.open("' + event.currentTarget.src + '",null,true);';
    window.parent.postMessage(x, "*");
  }
}
